// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".messageThreadInput__messageInput___3fg4a{min-height:50px;max-height:160px;background-color:#fff;display:flex;flex-direction:column;flex-shrink:0;box-shadow:0 -1px 6px 0 rgba(201,201,201,.3)}.messageThreadInput__messageInput___3fg4a.messageThreadInput__hasError___p9Jkf{border-top:1px solid red;border-bottom:1px solid red}.messageThreadInput__messageInput___3fg4a.messageThreadInput__isInputHidden___2baqG{display:none}.messageThreadInput__attachmentsPreview___3MDNX{display:flex}.messageThreadInput__lowerSection___3Mf0Z{width:100%;display:flex;padding:0 10px}.messageThreadInput__attachmentButtonWrapper___qVN8y,.messageThreadInput__buttonWrapper___3ZFeq{height:50px;display:flex;align-items:center}.messageThreadInput__textArea___28ON4{flex-grow:1;margin:0 5px;min-height:50px;height:50px;max-height:100px;border:0;padding:16px 5px}.messageThreadInput__submitButton___1HxeX{border-radius:50%;width:30px;height:30px;display:flex;justify-content:center;align-items:center}.messageThreadInput__sendIcon___3iG-0{width:15px;height:15px;margin:0 0 0 2px}html[dir=\"rtl\"] .messageThreadInput__sendIcon___3iG-0{transform:rotate(180deg);margin:0 2px 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"messageInput": "messageThreadInput__messageInput___3fg4a",
	"hasError": "messageThreadInput__hasError___p9Jkf",
	"isInputHidden": "messageThreadInput__isInputHidden___2baqG",
	"attachmentsPreview": "messageThreadInput__attachmentsPreview___3MDNX",
	"lowerSection": "messageThreadInput__lowerSection___3Mf0Z",
	"attachmentButtonWrapper": "messageThreadInput__attachmentButtonWrapper___qVN8y",
	"buttonWrapper": "messageThreadInput__buttonWrapper___3ZFeq",
	"textArea": "messageThreadInput__textArea___28ON4",
	"submitButton": "messageThreadInput__submitButton___1HxeX",
	"sendIcon": "messageThreadInput__sendIcon___3iG-0"
};
export default ___CSS_LOADER_EXPORT___;
